module.exports = __webpack_public_path__ + "static/img/wechat.f862eaf0.png";